import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async create(body: ApiSchemas['CreateMedicalDocumentDto']) {
    return wrapEndpoint(() =>
      client.POST('/medical-document', {
        body,
      }),
    )
  },
  async list(options?: ApiSchemas['ListMedicalDocumentDto']) {
    return wrapEndpoint(() =>
      client.GET('/medical-document', {
        params: {
          query: options,
        },
      }),
    )
  },
  async listLatestFromAttendance(attendanceId: number) {
    return wrapEndpoint(() =>
      client.GET('/medical-document/latest-from-attendance/{attendanceId}', {
        params: {
          path: {
            attendanceId,
          },
        },
      }),
    )
  },
  async delete(id: number) {
    return wrapEndpoint(() =>
      client.DELETE('/medical-document/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async printDocument(id: number, isDigitalSigned: boolean) {
    return wrapEndpoint(() =>
      client.PATCH('/medical-document/{id}/print', {
        parseAs: 'blob',
        params: {
          path: {
            id,
          },
          query: {
            isDigitalSigned,
          },
        },
      }),
    )
  },
}
